import { render, staticRenderFns } from "./sfc-tooltip-icon.vue?vue&type=template&id=710149a4&scoped=true&lang=pug&"
import script from "./sfc-tooltip-icon.vue?vue&type=script&lang=js&"
export * from "./sfc-tooltip-icon.vue?vue&type=script&lang=js&"
import style0 from "./sfc-tooltip-icon.vue?vue&type=style&index=0&id=710149a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710149a4",
  null
  
)

export default component.exports